module.exports = __webpack_public_path__ + "img/4.f0421f4b.png";